import { Component, OnDestroy, OnInit, forwardRef, DoCheck, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { ICardComponentInjectionToken } from '../../../_infrastructure/ValidationMessages/ExternalValidationDirective';
import { DomainCodes } from '../../../../models/const.DomainCodes';
import { CommonData } from '../../../_infrastructure/CommonData/CommonDataResolver';
import { AsyncDataService } from '../../../_infrastructure/AsyncData/AsyncDataService';
import { CommonDataService } from '../../../_infrastructure/CommonData/CommonDataService';
import { Subscription } from 'rxjs';
import { PreFilledProperty } from '../../../_infrastructure/Models/pre-filled-property.interface';
import { isNotNullOrUndefinedOrEmpty, isNullOrUndefined } from '../../../_infrastructure/objectUtils';


@Component({
  selector: 'sender-contacts-pre-stage',
  templateUrl: './sender-contacts-pre-stage.component.html',
  providers: [
    {
      provide: ICardComponentInjectionToken,
      useExisting: forwardRef(() => SenderContactsPreStageComponent)
    }],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
  standalone: false
})

export class SenderContactsPreStageComponent implements OnInit, OnDestroy, OnChanges {


  public countries: models.DimensionVM[];


  @Input() model: models.SenderContactsVM = {} as models.SenderContactsVM;
  @Input() isCertified: string = 'false';
  @Input() qualification: models.SenderQualificationVM = {} as models.SenderQualificationVM;

  private mainSubscription: Subscription = new Subscription();
  public preFilledProperties: PreFilledProperty[] = [];

  public mobilePattern: string = "^9\\d{8}$|^(?!\\+351\\s)(([+])(\\d{1,4})[\\\\ \\\\]\\d{1,12})$";
  public landlinePattern: string = "^(2|3)\\d{8}$|^(?!\\+351\\s)(([+])(\\d{1,4})[\\\\ \\\\]\\d{1,12})$";
  constructor(private asyncDataService: AsyncDataService, private commonDataService: CommonDataService) {
    this.mainSubscription.add(
      this.commonDataService.getDomain(DomainCodes.country).subscribe(
        result => this.countries = result.dimensions
      )
    );
  }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.model.isFirstChange()) {
      this.preFilledProperties.push({ name: "countryCode", preFilledValue: this.model.countryCode, hasValue: isNotNullOrUndefinedOrEmpty(this.model.countryCode) });
      this.preFilledProperties.push({ name: "address", preFilledValue: this.model.address, hasValue: isNotNullOrUndefinedOrEmpty(this.model.address) });
      this.preFilledProperties.push({ name: "postalCodeFirst", preFilledValue: this.model.postalCodeFirst, hasValue: isNotNullOrUndefinedOrEmpty(this.model.postalCodeFirst) });
      this.preFilledProperties.push({ name: "postalCodeLast", preFilledValue: this.model.postalCodeLast, hasValue: isNotNullOrUndefinedOrEmpty(this.model.postalCodeLast) });
      this.preFilledProperties.push({ name: "postalCodeFull", preFilledValue: this.model.postalCodeFull, hasValue: isNotNullOrUndefinedOrEmpty(this.model.postalCodeFull) });
      this.preFilledProperties.push({ name: "locality", preFilledValue: this.model.locality, hasValue: isNotNullOrUndefinedOrEmpty(this.model.locality) });
      this.preFilledProperties.push(
        {
          name: "mobilePhone",
          preFilledValue: this.model.mobilePhone,
          hasValue: isNotNullOrUndefinedOrEmpty(this.model.mobilePhone)
        });
      this.preFilledProperties.push(
        {
          name: "telephone",
          preFilledValue: this.model.telephone,
          hasValue: isNotNullOrUndefinedOrEmpty(this.model.telephone)
        });
      this.preFilledProperties.push(
        {
          name: "email",
          preFilledValue: this.model.email,
          hasValue: isNotNullOrUndefinedOrEmpty(this.model.email)
        });
    }
  }

  ngOnDestroy(): void {
    this.mainSubscription.unsubscribe();
  }

  public isFieldDisabled(name: string): boolean {
    let result = this.preFilledProperties.find(el => el.name == name).hasValue;
    return result && this.isCertified!='true';
  }

  public countryChanged(): void { }

  onPostalCodeChanged() {
    if (this.model.postalCodeFirst?.length == 4 && this.model.postalCodeLast?.length == 3) {
      try {
        this.asyncDataService.getPostalCodeDesignation(this.model.postalCodeFirst, this.model.postalCodeLast).subscribe(designation => {
          this.model.postalDesignation = designation;
          this.model.postalCodeFull = this.model.postalCodeFirst + "-" + this.model.postalCodeLast;
        }, error => {
          console.log(error);
        });
      }
      catch (e) {
        console.log(e);
      }
    }
  }
}
